import { render, staticRenderFns } from "./MobileSwitchCam.vue?vue&type=template&id=2e099c31&"
import script from "./MobileSwitchCam.vue?vue&type=script&lang=ts&"
export * from "./MobileSwitchCam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports